import { useMainBackgroundContext } from './main-background-context';
import styles from './main-background.module.scss';

export const MainBackground = () => {
  const {
    backgroundImage,
    backgroundStyles,
    imageStyles,
  } = useMainBackgroundContext();

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        marginInline: 'auto',
        width: 'fit-content',
        ...backgroundStyles,
      }}
    >
      {backgroundImage && (
        <img
          src={backgroundImage}
          alt="background_image"
          style={{
            height: '100%',
            ...imageStyles,
          }}
        />
      )}
      <div className={styles.gradientDivBottom} />
      <div className={styles.gradientDivSideLeft} />
      <div className={styles.gradientDivSideRight} />
    </div>
  );
}